<template>
  <div class="manual-content card-item">
    <h3 class="text-align-center">Efectivo</h3>
    <p class="message-info has-text-centered">
      <span>Nuestro depósito en efectivo es pagando presencialmente en caja de sucursales BCI.</span>
    </p>
    <div class="transfer-process">
      <div class="transfer-card card-animation-content">
        <div class="card-item front-card">
          <div class="title-card">
            <h4 class="is-pulled-left">Antes de depositar</h4>
            <div class="icon-front is-pulled-right"><img src="@/ui/assets/img/instrucciones.svg"></div>
            <div class="is-clearfix" />
          </div>
          <div class="card-content content">
            <p>
              Debes considerar que el monto en pesos depende de la UF, por lo que es válido
              <b>solo por hoy.</b>
            </p>
            <p class="has-text-centered">¿Harás el depósito hoy?</p>
            <div class="buttons-group has-text-centered">
              <a href="#anchor-will-pay-today">
                <button
                  id="button-will-pay-today"
                  :disabled="willPayToday"
                  class="button is-rounded"
                  :class="[willPayToday ? 'is-button-primary' : 'is-button-secondary']"
                  @click="confirmTransaction([false, true])">
                  Sí, lo haré hoy
                </button>
              </a>
              <a href="#anchor-will-not-pay-today">
                <button
                  id="button-will-not-pay-today"
                  class="button is-rounded"
                  :class="[willPayToday === false ? 'is-button-primary' : 'is-button-secondary']"
                  :disabled="willPayToday === false"
                  @click="confirmTransaction([false, false]);">
                  No, aún no
                </button>
              </a>
            </div>
            <div v-if="willPayToday">
              <div class="anchor"><div id="anchor-will-pay-today" /></div>
              <p>¿Cómo <b>depositar</b> en la cuenta de Creditú?</p>
              <ol class="transfer-steps">
                <li>Ve a la sucursal del banco BCI más cercana.</li>
                <li>Rellena la papeleta de depósito y paga en la caja.</li>
                <li>Envía un correo a <a href="mailto:pagos@creditu.com">pagos@creditu.com</a> con la foto del comprobante.</li>
              </ol>
            </div>
            <p class="has-text-centered" style="color:red;">{{ errorMessage }}</p>
          </div>
        </div>
      </div>
      <div class="transfer-card card-animation-content">
        <div
          id="transfer-image"
          :class="{ 'rotate-left-leave-to': willPayToday !== undefined }"
          class="card-item front-card">
          <h4 class="has-text-centered">Deposita</h4>
          <div class="icon-back"><img src="@/ui/assets/img/transfiere.svg"></div>
        </div>
        <div
          id="card-right-content"
          :class="{ 'rotate-left-enter-to': willPayToday !== undefined, 'show': willPayToday !== undefined }"
          class="card-item back-card">
          <div v-if="willPayToday === true" id="card-content-will-pay-today">
            <div class="title-card">
              <h4 class="is-pulled-left">Deposita</h4>
              <div class="icon-front is-pulled-right"><img src="@/ui/assets/img/transfiere.svg"></div>
              <div class="is-clearfix" />
            </div>
            <p>Datos de la cuenta destino:</p>
            <ul class="account-data">
              <li>
                <div class="is-pulled-left"><span class="label">Titular</span>Creditu S.A.</div>
                <div class="is-clearfix" />
              </li>
              <li>
                <div class="is-pulled-left"><span class="label">RUT</span>76.594.721-9</div>
                <div class="is-clearfix" />
              </li>
              <li><span class="label">Banco</span>Banco de Crédito e Inversiones (BCI)</li>
              <li><span class="label">Tipo de cuenta</span>Cuenta Corriente</li>
              <li>
                <div class="is-pulled-left"><span class="label">Número de cuenta</span>35428546</div>
                <div class="is-clearfix" />
              </li>
              <li>
                <div class="is-pulled-left"><span class="label">Correo electrónico</span>pagos@creditu.com</div>
                <div class="is-clearfix" />
              </li>
            </ul>
          </div>
          <div v-else id="card-content-will-not-pay-today">
            <div class="anchor"><div id="anchor-will-not-pay-pay-today" /></div>
            <div class="title-card">
              <h4 class="is-pulled-left">¡Te esperamos!</h4>
              <div class="icon-front is-pulled-right"><img src="@/ui/assets/img/transfiere.svg"></div>
              <div class="is-clearfix" />
            </div>
            <p class="block p-4 has-text-centered">
              El monto en pesos que calculamos utiliza la UF y, en caso de aplicar,
              penalización por atraso. Por este motivo, solo aplica si quieres pagar durante el día de hoy.
            </p>
            <p class="block p-4 has-text-centered">
              Vuelve a entrar a verificar el monto el día que quieras pagar efectivamente.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>

export default {
  name: 'PayCashDeposit',
  data() {
    return {
      willPayToday: undefined,
      focusCard: false,
      errorMessage: ''
    };
  },
  mounted() {
    this.$emit('sendNameNextStep', 'choice');
  },
  methods: {
    async shakeSenora() {
      this.errorMessage = '';
      const element = this.$el.querySelector('#card-right-content');
      element.classList.remove('shaking');
      // eslint-disable-next-line no-unused-expressions
      element.offsetWidth;
      element.classList.add('shaking');
    },
    copy(event) {
      this.$copyText(event.path[2].childNodes[0].childNodes[1].data).then(result => {
        this.$emit('copySuccess', result);
      }).catch(error => {
        this.$emit('copyError', error);
      });
    },
    async confirmTransaction([showBackButton, showNextButton]) {
      this.$store.dispatch('setPaymentMethod', '');
      this.willPayToday = showNextButton;

      this.$emit('updateFooterButtons', [showBackButton, showNextButton]);
      // Creo la transacción
      // if (showNextButton) {
      //   this.createTransaction();
      // }
      // Elimino la transacción
      const { transactionId } = this.$store.state.paymentsModule.transactionData;
      if (showBackButton && transactionId) {
        // cancelTransaction(transactionId);
        this.$store.dispatch('deleteTransactionData');
        await this.shakeSenora();
      }
    }
  }
};
</script>
<style scoped>
  .message-info {
    background: #F2FBFB;
    padding: 20px;
    margin: 0.5rem 0rem 2rem 0rem;
    border-radius: 20px;
    font-family: var(--secondary-font);
    color: var(--color-nickel);
  }
  a {
    text-decoration-line: none;
  }
  .manual-content {
    margin: 30px auto 50px auto;
  }
  .transfer-process {
    display: flex;
    flex-wrap: wrap;
    font-size: 12px;
  }
  .transfer-process .transfer-card {
    width: calc(100%/3 - 30px);
    margin: 15px;
    flex: 1 0 auto;
  }
  .transfer-process .transfer-card .card-item {
    height: 100%;
    margin-bottom: 10px;
  }
  .transfer-process .transfer-card .card-item .focusCard {
    box-shadow: var(--primary);
  }
  .transfer-process .transfer-card .title-card {
    margin-bottom: 20px;
  }
  .transfer-process .transfer-card .icon-front{
    width: 60px;
  }
  .transfer-process .transfer-card .icon-back {
    width: 100%;
    max-width: 160px;
    margin: 40px auto 0px auto;
  }
  .transfer-process .transfer-card .button{
    margin: 10px auto;
  }
  .transfer-process .transfer-card .button-mobile-data {
    display: none;
  }
  .transfer-process .transfer-card .buttons-group{
    display: flex;
    flex-flow: row wrap;
    justify-content: space-around;
    margin:15px 0;
  }
  .account-data li {
    border-bottom: 1px solid #cccccc;
    font-size: 12px;
    margin-top: 5px;
    padding: 2px 0;
  }
  .account-data li span.label {
    font-size: 8px;
    font-weight: bold;
    display: block;
  }
  .account-data li .fa-copy{
    margin-top:13px;
    margin-right: 15px;
  }
  .account-data li a.is-pulled-right {
    transition: filter 0.3s ease 0.3s;
  }
  .account-data li a.is-pulled-right:active {
    filter: drop-shadow(0 0 0 red);
    transition: filter 0s;
  }
  .transfer-steps {
    list-style: none;
    padding-left: 1rem;
    counter-reset: circle-counter;
    margin: 20px 0px;
  }
  .transfer-steps li {
    counter-increment: circle-counter;
    margin-bottom: 1rem;
    padding-left: 15px;
    position: relative;
  }
  .transfer-steps li::before {
    content: counter(circle-counter);
    background: var(--primary);
    width: 1.5rem;
    height: 1.5rem;
    border-radius: 50%;
    display: inline-block;
    font-size: 0.75rem;
    line-height: 1.5rem;
    color: #fff;
    text-align: center;
    margin-right: 0.5rem;
    position: absolute;
    top: -2px;
    left: -15px;
  }
  @media (max-width: 1100px) {
    .transfer-process {
      font-size: 10px;
    }
    .transfer-process .transfer-card .icon-front{
    width: 40px;
    }
    .title-card h4 {
      font-size: 16px;
    }
    .account-data li {
      font-size: 10px;
    }
    .transfer-process .transfer-card .button{
      font-size: 12px;
    }
  }
  @media (max-width: 930px) {
    .transfer-process .transfer-card .button{
    padding: 10px 20px;
    }
  }
  @media (max-width: 870px) {
    .transfer-process .transfer-card {
      width: 100%;
      max-width: 400px;
      margin: 15px auto;
    }
    .transfer-process {
      font-size: 12px;
    }
    .transfer-process .transfer-card .icon-front{
    width: 60px;
    }
    .title-card h4 {
      font-size: 20px;
    }
    .account-data li {
      font-size: 12px;
    }
    .transfer-process .transfer-card .button{
      font-size: 14px;
    }
    .transfer-process .transfer-card .button-mobile-data {
      display: block;
    }
    .transfer-process .transfer-card .button-desktop-data {
      display: none;
    }
    .anchor{
      position: relative;
    }
    #anchor-will-pay-today,  #anchor-not-transferred {
      position: absolute;
      margin-top: -65px;
    }
  }
  .shaking {
    animation: shake 0.82s cubic-bezier(.36,.07,.19,.97) both;
    transform: translate3d(0, 0, 0);
    backface-visibility: hidden;
    perspective: 1000px;
    box-shadow: 0px 0px 10px var(--primary);
  }
  @keyframes shake {
    10%, 90% {
      transform: translate3d(-1px, 0, 0);
    }
    20%, 80% {
      transform: translate3d(2px, 0, 0);
    }
    30%, 50%, 70% {
      transform: translate3d(-4px, 0, 0);
    }
    40%, 60% {
      transform: translate3d(4px, 0, 0);
    }
  }
</style>
